import { Component, Input } from '@angular/core';

import { ProfileFamily } from '../../data/models/collections/profile-family';

@Component({
  selector: 'placeme-status-gauge',
  templateUrl: './status-gauge.component.html',
  styleUrls: ['./status-gauge.component.scss'],
})
export class StatusGaugeComponent {
  @Input() profiles: ProfileFamily[];

  @Input() set value(value: number) {
    this.progressValue = value % 100;
  }
  progressValue: number;
}
